export default {
  init() {
    this.stickyTopAds();
  },

  stickyTopAds() {
    const stickyClass = 'mgs-sticky';
    let isStickyApplied = false; // Controle para garantir que a classe só seja aplicada uma vez

    // Função para verificar se o elemento está fora do viewport
    function isOutOfViewport(element) {
      const rect = element.getBoundingClientRect();
      return rect.top < 0 || rect.bottom > (window.innerHeight || document.documentElement.clientHeight);
    }

    // Função principal para gerenciar a classe sticky
    function controlSticky() {
      const adElement = document.querySelector('#mgs-main > div.mgs-ads');

      if (!adElement) {
        console.error('*** Elemento #mgs-main > div.mgs-ads não encontrado!');
        return;
      }

      // Verifica se o elemento está fora do viewport e a classe ainda não foi aplicada
      if (isOutOfViewport(adElement) && !isStickyApplied) {
        // Aplica a classe sticky e define o estado como aplicado
        isStickyApplied = true;
        adElement.classList.add(stickyClass);
        console.log('*** Classe mgs-sticky aplicada.');

        // Remove a classe após 5 segundos
        setTimeout(() => {
          adElement.classList.remove(stickyClass);
          console.log('*** Classe mgs-sticky removida após 5 segundos.');
          // callAnotherAd(); // Chama a função para outra publicidade
        }, 3000);

        // Remove event listeners após a classe ser aplicada
        window.removeEventListener('scroll', controlSticky);
        window.removeEventListener('resize', controlSticky);
      }
    }

    // Função para chamar outra publicidade
    // function callAnotherAd() {
    //   console.log('*** Chamada para anchorads');

    //   if(blocoAnchorSlot){
    //     googletag.display(blocoAnchorSlot.getSlotElementId());
  
    //     setInterval(function() {
    //       googletag.pubads().refresh([blocoAnchorSlot]);
    //     }, 30000);
    //   } else {
    //     console.log('*** blocoAnchorSlot não acessível!!!');
    //   }
    // }

    // Adicionar eventos para monitorar scroll e resize
    window.addEventListener('scroll', controlSticky);
    window.addEventListener('resize', controlSticky);

    // Garantir a limpeza dos eventos na página
    window.addEventListener('beforeunload', () => {
      window.removeEventListener('scroll', controlSticky);
      window.removeEventListener('resize', controlSticky);
    });
  }
};
